<template>
  <div class="mb-3">
    <label v-if="label" class="form-label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>
    
    <slot></slot>
    
    <div v-if="error" class="invalid-feedback d-block">
      {{ getErrorMessage(error) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormField',
  
  props: {
    label: { type: String, default: '' },
    required: { type: Boolean, default: false },
    error: { type: [String, Array], default: null }
  },

  methods: {
    getErrorMessage(error) {
      if (Array.isArray(error)) {
        return error[0]
      }
      return error
    }
  }
}
</script>

<style scoped>
.form-label {
  font-weight: 500;
  color: #1A0054;
  margin-bottom: 0.5rem;
}
</style>